import {
  ApexChartsTypeProp,
  YaxisHighestDigitOptions,
} from '@/components/common/apex-charts'

/**
 * @description:
 * feature refs:
 * - https://www.notion.so/ikala/FE-UI-Deep-Report-Y-babd360f1ef24c6589dc25c928459c3f?pvs=4
 * - https://www.notion.so/ikala/UIUX-KD-Y-7bee6ec9a5e04c5b8cd6a2b22b84b4d0?pvs=4
 */
const mapHighestDigit = (
  num: number,
  options?: {
    isPercentage?: boolean
    type?: ApexChartsTypeProp
  } & YaxisHighestDigitOptions,
): number => {
  if (num === 0) {
    return 0
  }

  if (options?.isPercentage) {
    num *= 100
  }

  const sign = Math.sign(num)
  const absNum = Math.abs(Math.floor(num))
  const digitLength = options?.digitLength ?? absNum.toString().length
  const roundingFactor = 10 ** (digitLength - 1)
  const baseValue = Math.floor(absNum / roundingFactor) * roundingFactor

  let result =
    options?.method === 'floor' ? baseValue : baseValue + roundingFactor

  if (options?.isPercentage) {
    result /= 100
  }

  if (options?.type === 'bar' && !options?.isPercentage) {
    result *= 1.1
  }

  return sign * result
}
export default mapHighestDigit
